import React, { useState, useEffect } from "react";
import SelectStyled from "../Select";
import enumChoice, { getEnumItem, makeEnumFriendly } from "../../enum";
import FilterableForm from "../common/filterableForm";

interface UserFilterProps {
  onClose: () => void;
}

function UserFilter({  onClose }: UserFilterProps) {  

  return (
    
    <FilterableForm
      title="User Filters"
      fields={[
          { name: "id", label: "ID", type: "number", defaultValue: "" },
          { name: "username", label: "Username", type: "text", defaultValue: '' },
          { name: "email", label: "Email", type: "text", defaultValue: '' },
          { name: "is_active", label: "Is Active", type: "checkbox", defaultValue: true },
          { name: "is_staff", label: "Is Staff", type: "checkbox", defaultValue: true },
          { name: "is_superuser", label: "Is Staff", type: "checkbox", defaultValue: true },
      ]}
      onClose={onClose}
    />



  );
}

export default UserFilter;
